/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import Tappable from 'app/components/commons/Tappable';
import { ASCENDING, DESCENDING } from 'app/constants/sortDirTypes';

type Props = {
  children: any,
  main?: boolean,
  mobileVisible?: boolean,
  onClick?: () => void,
  right?: boolean,
  size?: 'large' | 'medium' | 'small',
  sortDirection?: ASCENDING | DESCENDING,
  pad?: boolean,
};

const defaultProps = {
  main: false,
  mobileVisible: false,
  onClick: undefined,
  right: false,
  size: undefined,
  sortDirection: undefined,
  pad: false,
};

const Heading = glamorous.div(
  ({ main, mobileVisible, size, sortDirection, theme }) => ({
    display: mobileVisible ? 'block' : 'none',
    flexGrow: main ? 1 : 0,
    justifyContent: main ? 'flex-start' : undefined,
    paddingRight: theme.spacing.small,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    '&::after': {
      content: {
        [ASCENDING]: '"\\00a0\\25B2"',
        [DESCENDING]: '"\\00a0\\25BC"',
      }[sortDirection],
      fontSize: '0.75em',
      marginTop: '0.25em',
    },
    [theme.mediaQuery.desktopAndUp]: {
      display: 'flex',
      width:
        {
          small: 90,
          medium: 130,
          large: 150,
        }[size] || 120,
    },
  }),
  ({ right }) =>
    (right
      ? {
        justifyContent: 'flex-end',
      }
      : {}),
  ({ pad, theme }) =>
    (pad
      ? {
        paddingLeft: theme.spacing.default,
      }
      : {}),
);

function ChallengesHeading({
  children,
  main,
  mobileVisible,
  onClick,
  right,
  size,
  sortDirection,
  pad,
}: Props) {
  return onClick ? (
    <Tappable
      component={Heading}
      right={right}
      main={main}
      size={size}
      sortDirection={sortDirection}
      onTap={onClick}
      mobileVisible={mobileVisible}
      pad={pad}
    >
      {children}
    </Tappable>
  ) : (
    <Heading main={main} size={size} right={right} mobileVisible={mobileVisible} pad={pad}>
      {children}
    </Heading>
  );
}

ChallengesHeading.defaultProps = defaultProps;

export default ChallengesHeading;
